import React from "react";
import image from "../images/Camp/Copertina.png";

import Titolo from "../commons/Titolo";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";

import Space from "../commons/Space";
import SpaceL from "../commons/SpaceL";

import insta from "../icone/icons8-instagram-48.png";
import facebook from "../icone/icons8-facebook-48.png";
import foto1 from "../images/Camp/Instagram post - 3.png";
import foto2 from "../images/Camp/Instagram post - 4.png";
import foto3 from "../images/Camp/Instagram post - 6.png";
import foto4 from "../images/Camp/Instagram post - 7.png";
import foto5 from "../images/Camp/Instagram post - 8.png";
import foto6 from "../images/Camp/Instagram post - 10.png";



function CampEstivo() {
    const volantino = "/documents/Camp/Volantino_IlCignoSummerCamp.pdf";
    const regolamento = "/documents/Camp/Regolamento_IlCignoSummerCamp26.pdf";
    const form = "https://docs.google.com/forms/d/e/1FAIpQLScoaalAZMmGzBrrewbqEw8I0S2QB5_1heL-y0_pVmATTng3pw/viewform";

    return (
        <div>
            <ScrollToTopOnMount />
            <Titolo title={"Summer Camp"} backgroundImage={image} />

            <div style={container}>
                {/* HERO */}
                <div style={heroBox} className="text-center">
                    <h1 style={titleStyle}>Il Cigno Summer Camp</h1>

                    <h3>8 giugno - 24 luglio</h3>
                    <p>
                        Il nostro Summer Camp a Sesto San Giovanni è un centro estivo dedicato ai bambini dai 5 agli 11 anni con attività sportive,
                        gite, laboratori creativi e corso di nuoto giornaliero nella piscina del centro.
                    </p>

                    <p style={subtitle}>
                        Scegli liberamente le settimane che preferisci 🗓️
                    </p>

                    <div style={nuotoBox}>
                        🏊‍♂️ Corso di nuoto tutti i giorni incluso
                    </div>

                    <div style={infoBox}>
                        <strong>Lunedì - Venerdì</strong><br />
                        <strong>8:00 - 17:00</strong><br />
                        <strong>5 - 11 anni</strong>
                    </div>
                    <br/>

                    <a href={volantino} download className="btn" style={btnOrange}>
                        Scarica Volantino
                    </a>
                </div>

                {/* OPEN DAY */}
                <div style={openDayBox}>
                    <h2 style={sectionTitle}>Open Day Summer Camp ☀️</h2>

                    <p>
                        Vieni a scoprire il nostro Summer Camp:
                        presenteremo le attività, il planning settimanale,
                        il centro sportivo e risponderemo a tutte le domande delle famiglie.
                    </p>

                    <div style={openDayDates}>
                        <div>📍 Centro Sportivo Il Cigno</div>
                        <div>🗓️ Martedì 19 maggio – ore 19:30</div>
                        <div>🗓️ Venerdì 22 maggio – ore 19:45</div>
                        <div>🗓️ Sabato 23 maggio – ore 19:00</div>
                        <div>🗓️ Martedì 26 maggio – ore 19:30</div>
                        <div>🗓️ Venerdì 29 maggio – ore 20:00</div>
                    </div>

                    <p style={{ marginTop: "1em" }}>
                        La partecipazione è gratuita ma è richiesta la prenotazione.
                    </p>

                    <a
                        href={"https://docs.google.com/forms/d/e/1FAIpQLSdPtD9fvkjUUZJTEmx8Kh7Y8DuKUwQeeqCvpltCtostvniRCw/viewform?usp=header"}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-success"
                        style={btnBlue}
                    >
                        Prenota Open Day
                    </a>
                </div>

                <div className="d-flex flex-row container-news" style={{ overflowX: "auto", marginTop: "1em" }}>
                    <img src={foto1} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto4} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto3} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto5} className="img-fluid img-thumbnail news-img" alt="..." />
                    <img src={foto2} className="img-fluid img-thumbnail news-img" alt="..." />

                    <img src={foto6} className="img-fluid img-thumbnail news-img" alt="..." />
                </div>

                {/* SETTIMANE */}
                <div style={weeksBox}>
                    <h2 style={sectionTitle}>Massima flessibilità</h2>

                    <p>
                        Iscrivi tuo figlio/a scegliendo <strong>una o più settimane</strong>
                        <span/> in base alle tue esigenze.
                    </p>

                    <div style={weeksList}>
                        <div>📅 <strong>Settimana 1</strong>: 8–12 giugno</div>
                        <div>📅 <strong>Settimana 2</strong>: 15–19 giugno</div>
                        <div>📅 <strong>Settimana 3</strong>: 22–26 giugno</div>
                        <div>📅 <strong>Settimana 4</strong>: 29 giugno – 3 luglio</div>
                        <div>📅 <strong>Settimana 5</strong>: 6–10 luglio</div>
                        <div>📅 <strong>Settimana 6</strong>: 13–17 luglio</div>
                        <div>📅 <strong>Settimana 7</strong>: 20–24 luglio</div>
                    </div>
                </div>

                <SpaceL />

                {/* ATTIVITÀ */}
                <div style={highlightBox}>
                    <h2 style={sectionTitle}>Un’esperienza completa</h2>

                    <div style={featureList}>
                        <div>⚽ Multisport</div>
                        <div>🎨 Laboratori creativi</div>
                        <div>🏊‍♂️ Corso di nuoto giornaliero</div>
                        <div>🍽️ Servizio catering incluso</div>
                        <div>🎒 Gita organizzata ogni settimana</div>
                        <div>💦 Piscina all’aperto con scivoli</div>
                    </div>
                </div>

                <SpaceL />



                <SpaceL />

                {/* ISCRIZIONE */}
                <div className="text-center">
                    <h2 style={sectionTitle}>Come iscriversi</h2>

                    <div style={cardContainer}>

                        <div style={card}>
                            <div style={step}>1</div>
                            <h3>Compila il modulo</h3>
                            <a href={form} target="_blank" rel="noreferrer"
                               className="btn btn-success"
                               style={btnBlue}>
                                Apri modulo
                            </a>
                        </div>

                        <div style={card}>
                            <div style={step}>2</div>
                            <h3>Regolamento</h3>
                            <a href={regolamento} download
                               className="btn btn-success"
                               style={btnBlue}>
                                Scarica
                            </a>
                            <p>Oppure ritiralo in segreteria</p>
                        </div>

                        <div style={card}>
                            <div style={step}>3</div>
                            <h3>Pagamento</h3>
                            <p>Conferma iscrizione in segreteria <br/> (a partire da lunedì 11 maggio)</p>
                        </div>

                    </div>

                    <p style={{ marginTop: "1em" }}>
                        L’iscrizione è valida solo al completamento dei passaggi.
                    </p>

                    <strong>⚠️ Posti limitati ogni settimana</strong>
                </div>

                <SpaceL />

                {/* CTA */}
                <div className="text-center" style={ctaBox}>
                    <h2 style={sectionTitle}>Prenota il tuo posto</h2>

                    <a href={form}
                       target="_blank"
                       rel="noreferrer"
                       className="btn btn-success"
                       style={ctaButton}>
                        Iscriviti ora
                    </a>

                    <div style={contacts}>
                        <p>📞 02 2401 006</p>
                        <p>✉️ info@ilcignosport.it</p>
                        <p>Via Fiorani, 74 - Sesto San Giovanni</p>
                    </div>

                    <div>
                        <a href="https://www.instagram.com/centrosportivoilcigno/?hl=it">
                            <img src={insta} alt="instagram" />
                        </a>
                        <a href="https://www.facebook.com/ilcignosport.it/?locale=it_IT">
                            <img src={facebook} alt="facebook" />
                        </a>
                    </div>
                </div>

                <Space />
            </div>
        </div>
    );
}

/* STILI */

const container = {
    padding: "1em",
    maxWidth: "900px",
    margin: "0 auto"
};

const heroBox = {
    background: "linear-gradient(135deg, #fff5f2, #ffffff)",
    padding: "2em",
    borderRadius: "20px"
};

const titleStyle = {
    color: "#EC635B",
    fontFamily: "Wedges",
    fontSize: "2.5em"
};

const subtitle = {
    fontSize: "1.2em"
};

const nuotoBox = {
    marginTop: "1em",
    padding: "1em",
    background: "#E8F6FA",
    borderRadius: "15px",
    color: "#4B8DA4",
    fontWeight: "bold"
};

const infoBox = {
    marginTop: "1em",
    padding: "1em",
    background: "#fff",
    borderRadius: "15px",
    display: "inline-block",
    lineHeight: "1.6"
};

const weeksBox = {
    background: "#ffffff",
    padding: "2em",
    borderRadius: "20px",
    textAlign: "center",
    boxShadow: "0 8px 20px rgba(0,0,0,0.06)"
} as const

const weeksList = {
    display: "flex",
    flexDirection: "column",
    gap: "0.8em",
    marginTop: "1em",
    textAlign: "left",
    maxWidth: "500px",
    marginLeft: "auto",
    marginRight: "auto"
} as const;

const highlightBox = {
    background: "#FFF3E6",
    padding: "2em",
    borderRadius: "20px",
    textAlign: "center"
} as const;

const featureList = {
    marginTop: "1em",
    display: "flex",
    flexDirection: "column",
    gap: "0.6em"
} as const;

const sectionTitle = {
    color: "#EC635B"
};

const cardContainer = {
    display: "flex",
    flexDirection: "column",
    gap: "1.5em",
    marginTop: "1em"
} as const;

const card = {
    background: "white",
    padding: "2em",
    borderRadius: "20px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)"
};

const step = {
    fontSize: "2em",
    color: "#EC635B"
};

const btnOrange = {
    margin: "0.5em",
    backgroundColor: "#F5A648",
    borderColor: "#F5A648",
    color: "white"
};

const btnBlue = {
    backgroundColor: "#4B8DA4",
    borderColor: "#4B8DA4"
};

const ctaBox = {
    padding: "2em"
};

const ctaButton = {
    padding: "1em 2em",
    fontSize: "1.2em",
    backgroundColor: "#4B8DA4",
    borderColor: "#4B8DA4"
};

const contacts = {
    marginTop: "2em",
    fontSize: "0.9em",
    color: "gray"
};
const openDayBox = {
    marginTop: "2em",
    background: "#EEF8F2",
    padding: "2em",
    borderRadius: "20px",
    textAlign: "center",
    boxShadow: "0 8px 20px rgba(0,0,0,0.05)"
} as const;

const openDayDates = {
    marginTop: "1em",
    display: "flex",
    flexDirection: "column",
    gap: "0.5em",
    fontWeight: "500"
} as const;

export default CampEstivo;